import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import './index.less';

const RuleIconText = () => {
  return (
    <div className="rule-icon-invite-wrapper">
      <Tooltip
        title="创建收品池及场次，然后通过选择规则标签圈选商品，邀约商品对应的采销、商家等角色提报个性化素材。"
        placement="bottom"
      >
        <div>
          规则邀约
          <QuestionCircleOutlined style={{ marginLeft: 4 }} />
        </div>
      </Tooltip>
      <div className="img">
        <img
          src="https://img10.360buyimg.com/imagetools/jfs/t1/110446/21/24801/584/623ca79eEe7b403be/d8626ad0ff390416.png"
          alt=""
        />
      </div>
    </div>
  );
};

export default RuleIconText;
